import { configureTooManyRequests } from '@zenlayer/util';

/**
 * 初始化 429 Too Many Requests 重试策略。
 *
 * 后端限流返回 429 时，fetch 层按 `Retry-After` / 指数退避透明重试（最多 3 次），业务无感知；
 * 重试耗尽仍为 429 则由 util 层直接整页跳转 /error?code=429（location.href，会 reload），
 * 行为与 CF block 一致——业务侧无需再挂 429 拦截器。
 *
 * 我们的 429 语义单一（均为限流、可重试），故所有 429 一律重试。
 * 单次等待上限 10s；无 Retry-After 时退避 1s→2s→4s（叠加抖动），最坏总等待约 7~30s。
 */
export const setupTooManyRequests = () => {
  configureTooManyRequests({
    enabled: true,
    maxRetries: 3,
    maxDelay: 10000,
    baseDelay: 1000,
    blockRedirectUrl: () => '/error?code=429',
  });
};
